export default __webpack_public_path__ + "static/media/about-img-2.ba1f5c05.png";